import { Button, DialogContent, DialogTitle, Link, Typography } from '@mui/material';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import { InfoIcon } from 'assets';

import styles from './InfoDialog.module.scss';

export interface InfoDialogProps extends DialogProps {
  title: string;
  confirmText?: string;
  onConfirm: () => void;
  footerLink?: { text: string; onClick: () => void };
}

export function InfoDialog({ onConfirm, title, confirmText, footerLink, ...rest }: InfoDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} className={styles.dialog}>
      <DialogTitle textAlign='center' height={96}>
        <InfoIcon color='primary' sx={{ fontSize: '6.1rem' }} />
      </DialogTitle>
      <DialogContent>
        <Typography component='p' variant='body5'>
          {title}
        </Typography>

        <Button variant='contained' onClick={onConfirm} className={styles.formButton}>
          {confirmText || t('ok', { ns: 'auth' })}
        </Button>

        {footerLink && (
          <Link component='button' variant='body2' onClick={footerLink.onClick} className={styles.footerLink}>
            {footerLink.text}
          </Link>
        )}
      </DialogContent>
    </Dialog>
  );
}
